import $ from 'jquery';

var elements = [...document.querySelectorAll('.js-equal-height')];

elements.forEach(function(element) {

  var cards = [...element.querySelectorAll('[data-eq]')];
  var maxHeight = 0;

  cards.forEach(function(card) {
      var cardHeight = card.clientHeight;
      if (cardHeight > maxHeight) {
          maxHeight = cardHeight;
      }
  });
  
  // Set the same maximum height for all elements
  cards.forEach(function(card) {
      card.style.height = maxHeight + 'px';
  });
});

